export default function webPushConfiguration(newConfiguration) {
    this.applicationServerKey = null;
    this.serviceWorker = null;

    this.apiUrlPrefix = 'https://api.horisen.pro/news/v1';
    this.apiEndpointFormat = '/forms/{formUuid}/activities';
    this.apiTestEndpointFormat = '/forms/{formUuid}/test';

    this.url = null;

    this.identifier = null;
    this.serviceUuid = null;
    this.formUuid = null;

    this.autoRegisterWorker = true;
    this.workerFile = 'service-worker.js';
    this.autoRestoreSubscription = true;
    this.notifyButton = null;
    this.whenUnsubscribed = 'keep_identity'; // keep_identity, 'remove_identity'
    this.autoSubscribe = false;
    this.logEnable = false;

    this.data = {};
    this.headers = {};
    this.createSubscription = {
        url: null,
        method: "POST",
        data: {},
        headers: {}
    }
    this.updateSubscription = {
        url: null,
        method: "POST",
        data: {},
        headers: {}
    }
    this.removeSubscription = {
        url: null,
        method: "POST",
        data: {},
        headers: {}
    };
    this.testNotification = {
        url: null,
        method: "POST",
        data: {},
        headers: {}
    };
    this.onSend = function (e) { };

    for (var i in newConfiguration) {
        this[i] = newConfiguration[i];
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/services/webpush-configuration.js
// module id = 17
// module chunks = 0